import { render, staticRenderFns } from "./changeCard.vue?vue&type=template&id=3ec71031"
import script from "./changeCard.vue?vue&type=script&lang=js"
export * from "./changeCard.vue?vue&type=script&lang=js"
import style0 from "./changeCard.vue?vue&type=style&index=0&id=3ec71031&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports